import React from 'react';

import { useRecoilState } from 'recoil';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';

// !Components
import { DatasheetIcon } from './DatasheetIcon';
import { RohsIcon } from './RohsIcon';
import { getSupplierNameCorePart } from '../../ultils';
import './PartNumberCellRenderer.scss';
import { callGTMAnalytics } from '../../helper/analyticsTag';

interface IProps {
    data: any;
}

export const PartNumberCellRendererVerticalViewCellRenderer: React.FC<
    IProps
> = ({ data }) => {
    const dataSupplierName = data?.productVariations
        ? getSupplierNameCorePart(data?.productVariations)
        : data?.vendor?.value;

  const [utagObject] = useRecoilState(utagObjectAtom);

    return (
        <div className="">
            <div className="container part-number-container-vertal-view">
                <div className="icon-section">
                    {data.primaryDatasheetUrl ? (
                        <DatasheetIcon primaryDatasheetUrl={data.primaryDatasheetUrl} />
                    ) : (
                        ''
                    )}
                    <RohsIcon rohsStatus={data.rohsStatus} />
                </div>
                <div className="left-content">
                    <img
                        alt="product_image"
                        className="product-image"
                        src={
                            data.primaryPhotoUrl
                                ? data.primaryPhotoUrl
                                : 'https://media.digikey.com/Photos/NoPhoto/NoPhoto_sml.jpg'
                        }
                    />
                </div>

                <div className="d-flex justify-content-between">
                    <div className="right-content">
                        {data.url !== '' ? (
                            <a
                                className="right-content__mnf-part-number"
                                href={data?.url}
                                target="_blank"
                                rel="noreferrer"
                                onClick={()=>callGTMAnalytics(utagObject, "Link to Part", [data])}
                                cookie-tracking={
                                    data &&
                                        data.crossType &&
                                        data.crossType?.crossName !== undefined
                                        ? 'ref_page_event=Link to Part;ref_page_category=' +
                                        data.crossType.crossName
                                        : ''
                                }
                            >
                                {data.manufacturerProductNumber}
                            </a>
                        ) : (
                            <span className="right-content__mnf-part-number pe-none">
                                {data.manufacturerProductNumber}
                            </span>
                        )}
                        <span className="right-content__description">
                            {data.catalogDescription}
                        </span>
                        <span className="right-content__vendor">{dataSupplierName}</span>
                    </div>

                </div>
            </div>
        </div>
    );
};
